<!--
  - Copyright (c) 2018 BarD Software s.r.o
  -->

<template>
    <div>
        <div class="d-flex align-items-center">
            <h5 class="m-0">{{ member.name }}</h5>
            <span v-if="member.uid == team.ownerId"
                  class="ml-2 badge badge-pill badge-secondary">Owner</span>
            <div class="flex-fill"></div>
            <button class="btn btn-outline-secondary btn-icon btn-menu invite-cancel"
                    v-if="shouldShowRemoveButton()"
                    v-on:click="removeMember"
                    title="Remove from this team">
                <i class="fas fa-trash"></i></button>
        </div>
        <small>{{ member.email }}</small>
    </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-facing-decorator";
import {loadTeam, ParticipantDto, TeamDto} from "@/Teams";
import {TeamExpel} from "@/Routes";
import {updateDependencies} from "@/Dashboard";
import {handleXhrError} from "@/utils/Ui";

@Component()
export default class MemberItem extends Vue {
  @Prop()
  public member: ParticipantDto;

  @Prop()
  public team: TeamDto;

  @Prop
  public removeButton: boolean;

  public removeMember() {
    TeamExpel.invoke({ teamRefid: this.team.refid, userId: this.member.uid })
        .then(() => loadTeam(this.team.refid))
        .done(updateDependencies)
        .fail((jqXhr) => handleXhrError(jqXhr, 'Failed member remove'));
  }

  public shouldShowRemoveButton(): boolean {
    const uid = window.currentUserId;
    return this.removeButton != null && this.team.ownerId === uid && this.member?.uid !== uid;
  }
}

</script>
